<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.shipping_pickup') }}</h1>
      <div class="card__description card__margin">
        <p v-html="getDataPre()"></p>
        <div class="d-flex-responsive-map mb-3">
          <div id="orderMap"></div>
          <div v-if="pickupPoint" class="pickup-margin">
            <p class="font-weight-bold red">{{ pickupPoint.city }}, {{ $t('countries.' + pickupPoint.country) }}</p>
            <p class="mt-2 font-weight-bold">{{ $t('pickup.' + pickupPoint.info) }}</p>
            <p class="mt-2">{{ $t('messages.pickup_address') }}</p>
          </div>
        </div>
        <p v-html="getDataPost()"></p>
        <b-table-simple striped bordered responsive class="table-width">
          <b-thead>
            <b-tr>
              <b-th>
                {{ $t('messages.country') }}
              </b-th>
              <b-th>
                {{ $t('messages.shipping_costs') }}
              </b-th>
              <b-th>
                {{ $t('messages.shipping_costs_discount') }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="shippingPrice in shippingPrices" :key="shippingPrice.country">
              <b-td>
                {{ shippingPrice.country }}
              </b-td>
              <b-td>
                <div v-if="shippingPrice.price">€ {{ shippingPrice.price | round(2) }}</div>
                <div v-if="!shippingPrice.price">{{ $t('messages.not_available') }}</div>
              </b-td>
              <b-td>
                <div v-if="shippingPrice.price">
                  <div v-if="(shippingPrice.price - $store.state.shippingDiscount) <= 0">
                    {{ $t('messages.free') }}
                  </div>
                  <div v-if="(shippingPrice.price - $store.state.shippingDiscount) > 0">
                    € {{ (shippingPrice.price - $store.state.shippingDiscount) | round(2) }}
                  </div>
                </div>
                <div v-if="!shippingPrice.price">{{ $t('messages.not_available') }}</div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

import { productService } from '../services/product.service'

export default {
  name: 'about',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.shipping_pickup') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.shipping_pickup'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  data: function () {
    return {
      fields: [{
        key: 'country',
        label: this.$i18n.t('messages.country')
      }, {
        key: 'price',
        label: this.$i18n.t('messages.shipping_costs')
      }, {
        key: 'discount',
        label: this.$i18n.t('messages.shipping_costs_discount')
      }],
      shippingPrices: null,
      pickupPoints: null,
      pickupPoint: null,
      map: {
        timeout: null
      }
    }
  },
  computed: {
    mapIcon: function () {
      return Vue.prototype.$hostname.concat('/image/arrow-orange.png')
    }
  },
  methods: {
    getDataPre: function () {
      let dataUrl = 'i18n/shipping/' + this.$i18n.locale + '_pre.html'
      return require('@/' + dataUrl)
    },
    getDataPost: function () {
      let dataUrl = 'i18n/shipping/' + this.$i18n.locale + '_post.html'
      return require('@/' + dataUrl)
    },
    initializeMap: _.debounce(function () {
      if (this.pickupPoints && this.pickupPoints.length > 0) {
        let container = document.getElementById('orderMap')
        if (container) {
          let self = this
          // eslint-disable-next-line no-undef
          let map = new L.Map('orderMap', {
            fullscreenControl: true,
            center: [0, 0],
            zoom: 10
          })
          let markers = []
          // eslint-disable-next-line no-undef
          let mapIcon = L.icon({
            iconUrl: this.mapIcon,
            iconSize: [25, 30]
          })
          this.pickupPoints.forEach(function (pickupPoint) {
            // eslint-disable-next-line no-undef
            let marker = new L.Marker([pickupPoint.lat, pickupPoint.lng], {
              icon: mapIcon,
              title: pickupPoint.city + ', ' + self.$i18n.t('countries.' + pickupPoint.country),
              pickupPoint: pickupPoint
            })
            marker.on('click', function (e) {
              self.pickupPoint = e.sourceTarget.options.pickupPoint
            })
            marker.addTo(map)
            markers.push(marker)
          })
          // eslint-disable-next-line no-undef
          let group = new L.FeatureGroup(markers)
          map.fitBounds(group.getBounds(), {
            padding: [50, 50]
          })
          // eslint-disable-next-line no-undef, no-template-curly-in-string
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(map)
          this.map.initialized = true
        }
      }
    }, 500)
  },
  mounted: function () {
    let self = this
    window.addEventListener('resize', function () {
      if (self.map.timeout) {
        clearTimeout(self.map.timeout)
      }
      self.map.timeout = setTimeout(function () {
        self.initializeMap()
      }, 1000)
    })
  },
  created: function () {
    let loader = this.$loading.show()

    productService.fetchPickupPoints()
      .then((pickupPoints) => {
        this.pickupPoints = pickupPoints
        this.initializeMap()

        let self = this

        productService.fetchShippingPrices()
          .then((shippingPrices) => {
            shippingPrices.forEach(function (shippingPrice) {
              shippingPrice.country = self.$i18n.t('countries.' + shippingPrice.country)
            })

            this.shippingPrices = shippingPrices.sort(function (a, b) {
              let countryA = a.country.toString().toLowerCase()
              let countryB = b.country.toString().toLowerCase()

              if (countryA < countryB) {
                return -1
              } else if (countryA > countryB) {
                return 1
              } else {
                return 0
              }
            })

            loader.hide()
          }, () => {
            this.$store.commit('error', 'errors.shipping_costs')
            loader.hide()
          })
      }, () => {
        this.$store.commit('error', 'errors.pickup_points')
        loader.hide()
      })
  },
  beforeDestroy: function () {
    clearTimeout(this.map.timeout)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #orderMap {
    width: 100%;
    height: 300px;
  }

  .table-width {
    max-width: 600px;
  }

  .pickup-margin {
    margin-top: 10px;
  }

  .d-flex-responsive-map {
    display: block;
  }

  @media screen and (min-width: 768px) {
    #orderMap {
      width: 500px;
    }

    .pickup-margin {
      margin-top: 0px;
      margin-left: 20px;
    }

    .d-flex-responsive-map {
      display: -webkit-flex; /* Safari */
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Shipping.vue